import { Link } from "react-router-dom";
import { LEGAL_ORDER, ENTITY } from "../legal/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/20 bg-ink mt-24 overflow-hidden">
      {/* Upper grid */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 lg:grid-cols-12 gap-10">
        <div className="col-span-2 lg:col-span-5">
          <div className="font-anton text-4xl uppercase text-bone tracking-tighter">
            TOXIC<span className="text-blood">/</span>STREET
          </div>
          <p className="mt-4 text-ash text-xs leading-relaxed max-w-sm">
            DISCIPLINE OVER EVERYTHING. Built for the kids who refuse to fit in.
            Small batches. Big statements. No restocks.
          </p>
          <p className="mt-6 font-marker text-blood text-2xl">stay dangerous.</p>
          <form
            className="mt-8 flex max-w-sm border border-white/20"
            onSubmit={(e) => { e.preventDefault(); alert("WELCOME, REBEL."); }}
          >
            <input
              data-testid="footer-newsletter-email"
              type="email"
              required
              placeholder="GET DROP ALERTS"
              className="flex-1 bg-transparent px-4 py-3 text-bone text-xs font-mono tracking-[0.2em] uppercase focus:outline-none placeholder:text-ash"
            />
            <button
              data-testid="footer-newsletter-submit"
              type="submit"
              className="bg-blood text-bone px-5 text-xs tracking-[0.3em] uppercase font-mono hover:bg-bone hover:text-ink transition-colors"
            >
              JOIN
            </button>
          </form>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs tracking-[0.2em] uppercase text-ash mb-4">// SHOP</div>
          <ul className="space-y-2 text-sm text-bone font-mono">
            <li><Link to="/shop" className="hover:text-blood">All Drops</Link></li>
            <li><Link to="/shop?category=tees" className="hover:text-blood">Tees</Link></li>
            <li><Link to="/shop?category=hoodies" className="hover:text-blood">Hoodies</Link></li>
            <li><Link to="/shop?category=caps" className="hover:text-blood">Caps</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs tracking-[0.2em] uppercase text-ash mb-4">// HQ</div>
          <ul className="space-y-2 text-sm text-bone font-mono">
            <li><Link to="/manifesto" className="hover:text-blood">Manifesto</Link></li>
            <li><Link to="/order-lookup" className="hover:text-blood">Track Order</Link></li>
            <li><a className="hover:text-blood" href="mailto:rebel@toxicstreet.co">Contact</a></li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-blood">Admin</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs tracking-[0.2em] uppercase text-ash mb-4">// LEGAL</div>
          <ul className="space-y-2 text-sm text-bone font-mono">
            {LEGAL_ORDER.map((l) => (
              <li key={l.slug}>
                <Link
                  to={`/legal/${l.slug}`}
                  data-testid={`footer-legal-${l.slug}`}
                  className="hover:text-blood"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Mega wordmark — red glow, faded into solid ink, clipped at exact baseline */}
      <div className="relative select-none pointer-events-none overflow-hidden" style={{ height: "20vw", minHeight: "180px" }}>
        <div
          className="font-anton uppercase text-center leading-[0.85] tracking-tighter text-[28vw] sm:text-[22vw] text-bone whitespace-nowrap absolute left-0 right-0 bottom-[-7vw]"
          style={{
            textShadow:
              "0 0 24px rgba(204,0,0,0.55), 0 0 56px rgba(204,0,0,0.4), 0 0 120px rgba(204,0,0,0.3), 0 0 220px rgba(204,0,0,0.18)",
          }}
        >
          TOXIC<span className="text-blood">/</span>STREET
        </div>
        <div className="absolute inset-0 bg-[linear-gradient(to_bottom,transparent_0%,rgba(5,5,5,0.35)_45%,#050505_85%,#050505_100%)]" />
      </div>

      {/* Bottom strip — no gap above */}
      <div className="border-t border-white/15 bg-ink">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex flex-col lg:flex-row items-center justify-between gap-3">
          <span className="text-[10px] tracking-[0.3em] text-ash font-mono uppercase order-2 lg:order-1">
            © 2026 {ENTITY} // ALL RIGHTS RESERVED
          </span>
          <nav className="order-1 lg:order-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[10px] tracking-[0.25em] font-mono uppercase">
            {LEGAL_ORDER.map((l, i) => (
              <span key={l.slug} className="flex items-center">
                {i > 0 && <span className="text-blood/60 mr-4">/</span>}
                <Link
                  to={`/legal/${l.slug}`}
                  data-testid={`bottom-legal-${l.slug}`}
                  className="text-ash hover:text-bone transition-colors"
                >
                  {l.label}
                </Link>
              </span>
            ))}
          </nav>
          <span className="text-[10px] tracking-[0.3em] text-ash font-mono order-3">
            生き残る者が勝つ
          </span>
        </div>
      </div>
    </footer>
  );
}
